import { FlowGraph } from '../FlowGraph';
import type { NodeId, RotateOptions } from 'web';
import type { RotateData } from '@/types/node';

const DEFAULT_OPTIONS: RotateOptions = { rotation90: 0, flipHorizontal: false, flipVertical: false };

export class RotateView {
  constructor(
    private graph: FlowGraph,
    private nodeId: NodeId,
  ) {}

  getOptions(): RotateOptions {
    return this.graph.store.getNodeData<RotateData>(this.nodeId).options ?? DEFAULT_OPTIONS;
  }

  rotate90() {
    this.graph.wasmEdit((wasm) => {
      const options = this.getOptions();
      return wasm.setRotateOptions(this.nodeId, {
        ...options,
        rotation90: (options.rotation90 + 1) % 4,
      });
    });
    this.graph.updateNodeOutputs(this.nodeId);
  }

  flipHorizontal() {
    this.graph.wasmEdit((wasm) => {
      const options = this.getOptions();
      return wasm.setRotateOptions(this.nodeId, {
        ...options,
        flipHorizontal: !options.flipHorizontal,
      });
    });
    this.graph.updateNodeOutputs(this.nodeId);
  }

  flipVertical() {
    this.graph.wasmEdit((wasm) => {
      const options = this.getOptions();
      return wasm.setRotateOptions(this.nodeId, {
        ...options,
        flipVertical: !options.flipVertical,
      });
    });
    this.graph.updateNodeOutputs(this.nodeId);
  }

  reset() {
    this.graph.wasmEdit((wasm) => wasm.setRotateOptions(this.nodeId, DEFAULT_OPTIONS));
    this.graph.updateNodeOutputs(this.nodeId);
  }
}
